import { ButtonType, DialogFooterButtonsWidget, OutlineTextFieldWidget, TextLinkKind, TextLinkWidget } from '@tableau/widgets';
import React from 'react';

import { IIdentityPool } from '~src/authentication/serverApi/types/identityPools/IIdentityPool';
import { CreateUserIdentityService } from '~src/authentication/services/CreateUserIdentityService';
import { Messages } from '~src/codegen/Localize';
import { HelpService } from '~src/commonInfra/services/HelpService';
import { CommonStyles } from '~src/commonInfra/styles/CommonStyles';
import { IUser } from '~src/userManagement/users/serverApi/types/IUser';

export interface CreateLocalUserIdentityDialogProps {
  readonly dismiss: () => void;
  readonly close: (result: any) => void;
  readonly identityPool: IIdentityPool;
  readonly user: IUser;
  readonly isServerUser: boolean;
}

export const DIALOG_TESTID = 'create-local-user-identity-dialog';

export function CreateLocalUserIdentityDialog(props: CreateLocalUserIdentityDialogProps) {
  const [identifier, setIdentifier] = React.useState('');

  function onConfirmed() {
    props.dismiss();

    const identifierValue = identifier.length > 0 ? identifier : props.user.username;
    const poolName = props.identityPool?.id === 'DEFAULT' ? null : props.identityPool?.name;
    CreateUserIdentityService.createLocalIdentityForUser(props.user, poolName, identifierValue, props.isServerUser);
  }

  function dialogFooter() {
    return <DialogFooterButtonsWidget
      buttons={[
        {
          handleClick: props.dismiss,
          buttonType: ButtonType.Outline,
          children: Messages.cancel(),
          testId: `${DIALOG_TESTID}-cancel`
        },
        {
          handleClick: onConfirmed,
          buttonType: ButtonType.Primary,
          children: Messages.save(),
          testId: `${DIALOG_TESTID}-save`
        },
      ]}
      testId={`${DIALOG_TESTID}-footer`}
    />;
  }

  const identifierChangeCallback = (userInput: string) => setIdentifier(userInput);

  return <>
    <div style={{ paddingBottom: CommonStyles.Sizes.LargeSpace }}>
      {Messages.identityPools_CreateLocalUserIdentityAction_DialogDescription({
          USER_DISPLAY_NAME: props.user.displayName,
          IDENTITY_POOL_NAME: props.identityPool.name})}
      <br></br>
      <TextLinkWidget
        testId={'identity-pool-learn-more'}
        target={'_blank'}
        href={HelpService.getServerHelpUrlByCategory('idpools-user-identity-info')}
        kind={TextLinkKind.Standalone}>
        {Messages.learnMore()}
      </TextLinkWidget>
    </div>

    <label>{Messages.identityPools_CreateLocalUserIdentityAction_IdentifierLabel()}</label>
    <OutlineTextFieldWidget
      handleChange={identifierChangeCallback}
      testId={`${DIALOG_TESTID}-identifier`}
      disabled={false}
      text={identifier}
      placeholder={Messages.identityPools_CreateLocalUserIdentityAction_Identifier_placeholder()}
    />

    <div style={{ paddingTop: CommonStyles.Sizes.LargeSpace }}>
      {dialogFooter()}
    </div>
  </>;
}
